import { Component, Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Http, Response, Headers } from '@angular/http';
import { ProjectItem } from '../../project/index';
import { ErrorModel } from './index';
import { Router } from '@angular/router';
import { ClearanceItem } from '../../clearance-item/clearance-item.model';
import { AppService } from '../../app.service';

@Injectable()
export class MessageBrokerService {

    //Component Communication
    private projectNamesubject: BehaviorSubject<ProjectItem>;
    //Message to show in error screen
    private errorSubject: BehaviorSubject<ErrorModel> = new BehaviorSubject<ErrorModel>(new ErrorModel());
    private refreshLeftNavSubject: Subject<string> = new Subject<string>();
    private itemChangedSubject: Subject<ClearanceItem> = new Subject<ClearanceItem>();
    private itemDeletedSubject: Subject<string> = new Subject<string>();

    constructor(
        private _router: Router,
        private _appService: AppService
    ) {

        this.projectNamesubject = new BehaviorSubject<ProjectItem>(null);

    }

    setCurrentProject(project: ProjectItem, persistChange: boolean = false): void {
        if (persistChange)
            this._appService.addRecent(project).subscribe(refreshedProject => {
                if (refreshedProject) {
                    this.projectNamesubject.next(refreshedProject);
                }
            });
        else
            this.projectNamesubject.next(project);
    }

    getCurrentProject(): Observable<ProjectItem> {
        return this.projectNamesubject.asObservable();
    }

    setError(error: ErrorModel): void {
        this.errorSubject.next(error);
    }

    getError(): Observable<ErrorModel> {
        return this.errorSubject.asObservable();
    }
    showErrorScreen(error: ErrorModel): void {
        this.setError(error);
        this._router.navigateByUrl('\error');
    }

    private deleteProjectsubject: Subject<string> = new Subject<string>();

    setDeletedProject(projectId: string): void {
        this.deleteProjectsubject.next(projectId);
    }

    getDeletedProject(): Observable<string> {
        return this.deleteProjectsubject.asObservable();
    }

    sendMessageToRefreshLeftNav(projectName: string): void {
        this.refreshLeftNavSubject.next(projectName);
    }

    subscribeRefreshLeftNav(): Observable<string> {
        return this.refreshLeftNavSubject.asObservable();
    }

    itemHasChanged(item: ClearanceItem): void {
        this.itemChangedSubject.next(item);
    }

    subscribeToItemChanged(): Observable<ClearanceItem> {
        return this.itemChangedSubject.asObservable();
    }

    itemHasBeenDeleted(id: string): void {
        this.itemDeletedSubject.next(id);
    }

    subscribeToItemDeleted(): Observable<string> {
        return this.itemDeletedSubject.asObservable();
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/core/message-broker.service.ts